"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var index_scss_1 = __importDefault(require("./index.scss"));
exports.default = {
    menu_list_box_shadow: index_scss_1.default.menu_list_box_shadow,
    menu_list_item_avatar_margin: index_scss_1.default.menu_list_item_avatar_margin,
    menu_list_item_icon_min_width: index_scss_1.default.menu_list_item_icon_min_width,
    menu_list_item_min_height: index_scss_1.default.menu_list_item_min_height,
    menu_list_item_padding_horizontal: index_scss_1.default.menu_list_item_padding_horizontal,
    menu_list_item_padding_vertical: index_scss_1.default.menu_list_item_padding_vertical,
    menu_list_divider_border_color: index_scss_1.default.menu_list_divider_border_color,
    menu_list_font: index_scss_1.default.menu_list_font,
    menu_list_icon_transition_duration: index_scss_1.default.menu_list_icon_transition_duration,
    menu_list_min_width: index_scss_1.default.menu_list_min_width,
    menu_list_second_level_padding_left: index_scss_1.default.menu_list_second_level_padding_left,
    menu_list_third_level_padding_left: index_scss_1.default.menu_list_third_level_padding_left,
};
